import type React from 'react';
import { useEffect } from 'react';

const useHotKeys = (setIsOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  /**
   * @description Open and close the global search when the user presses the shortcut key ctrl+k or cmd+k
   * @param {KeyboardEvent} e - The keyboard event
   */
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setIsOpen((open) => !open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, [setIsOpen]);
};

export default useHotKeys;
